exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-open{overflow:inherit!important}.modal-open .modal{overflow-y:hidden}.disable-withdraw{font:inherit;font-size:1.9em;line-height:1.2;color:#fff;text-align:center;background:#ff4848;border-radius:4px;padding:.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a4af498","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/office/js/components/franchise_v5/affiliate_dashboard/index.vue
// module id = CJO0
// module chunks = 0